import React from 'react';
import Button from '../../ui/Button';
import { MapPinIcon, CheckCircleIcon } from '@heroicons/react/24/solid';
import PickupCodeInput from './PickupCodeInput';

const FulfillmentGroupControls = ({ 
  userRole, 
  fulfillmentGroupDetails, 
  isPickupCompleted, 
  handleConfirmPickup, 
  isConfirmingPickup 
}) => {
  if (!fulfillmentGroupDetails) {
    return null;
  }

  return (
    <div className="p-3 border-t border-gray-200 bg-gray-50">
      {userRole === 'buyer' && (
        <>
          {isPickupCompleted ? (
            <div className="flex flex-col items-center text-center py-4">
              <CheckCircleIcon className="h-12 w-12 text-green-500 mb-2" />
              <p className="text-lg font-medium text-gray-800">Pickup Complete!</p>
              <p className="text-sm text-gray-600">Thank you for your order.</p>
            </div>
          ) : (
            <div className="flex items-center justify-between space-x-3">
              <div className="flex-grow">
                <p className="text-lg font-medium text-gray-700">
                  Your Pickup Code: <span className="font-bold text-brand-teal text-2xl">{fulfillmentGroupDetails.pickupCode || '----'}</span>
                </p>
                <p className="text-sm text-gray-600">
                  Coordinate pickup details as needed. Present this code when you collect your items.
                </p>
              </div>
              {fulfillmentGroupDetails.pickupLocationAddress && (
                <Button
                  variant="secondary"
                  size="md"
                  onClick={() => window.open(fulfillmentGroupDetails.pickupLocationAddress.googleMapsUrl || `https://maps.google.com/?q=${encodeURIComponent(fulfillmentGroupDetails.pickupLocationAddress.fullAddress)}`, '_blank')}
                  className="flex-shrink-0"
                >
                  <MapPinIcon className="h-4 w-4 mr-1.5" />
                  Directions
                </Button>
              )}
            </div>
          )}
        </>
      )}

      {userRole === 'seller' && (
        <>
          {isPickupCompleted ? (
            <div className="text-center py-4">
              <CheckCircleIcon className="h-10 w-10 text-green-500 mx-auto mb-2" />
              <p className="text-md font-medium text-gray-800">Pickup Success! This part of the order is complete.</p>
              <p className="text-xs text-gray-600 mt-1">Funds will be processed according to the payment schedule.</p>
            </div>
          ) : (
            <PickupCodeInput
              onConfirm={handleConfirmPickup}
              isLoading={isConfirmingPickup}
              disabled={isConfirmingPickup || isPickupCompleted}
            />
          )}
        </>
      )}
    </div>
  );
};

export default FulfillmentGroupControls; 